'use client';

import clsx from 'clsx';

import { Icon, Link, Typography } from '@/components/core';
import { NavigationLinkStoryblok, SubMenuStoryblok } from '@/types/storyblok/storyblok-types';
import { parseStoryblokLinkObject } from '@/utils/storyblok';

import styles from './Submenu.module.scss';

type SubmenuProps = {
    blok: SubMenuStoryblok | NavigationLinkStoryblok;
    level: number;
    isNested?: boolean;
    openMenus?: string[];
    toggleMenuVisibility: (prevId: string, level: number) => void;
};
export const SubmenuMobile: React.FC<SubmenuProps> = ({ blok, level, isNested, openMenus, toggleMenuVisibility }) => {
    const renderNavigationLink = (linkBlok: NavigationLinkStoryblok) => (
        <div className={clsx(styles.mavigationLinkRoot)}>
            <Link
                className={clsx(styles.rowLink, styles[`level-${level}`])}
                href={parseStoryblokLinkObject(linkBlok.link)}
                target={linkBlok.link.target}
            >
                <div className={styles.rowLinkContent}>
                    <Typography looksLike="menu">{linkBlok.title}</Typography>
                </div>
            </Link>
        </div>
    );

    const renderSubMenu = (menuBlok: SubMenuStoryblok) => {
        const { subMenu } = menuBlok;
        const isActive = openMenus?.[level + 1] === menuBlok._uid;

        return (
            <div
                className={clsx(styles.root, styles.subMenu, {
                    [styles.isNested]: isNested,
                    [styles.isActive]: isActive,
                })}
            >
                <div
                    className={clsx(styles.rowLink, styles[`level-${level}`])}
                    onClick={() => toggleMenuVisibility(menuBlok._uid, level + 1)}
                >
                    <div className={styles.rowLinkContent}>
                        <Typography
                            looksLike="menu"
                            className={clsx(styles.title)}
                        >
                            {menuBlok.title}
                            <Icon
                                name="chevron"
                                className={clsx(styles.icon, { [styles.reverse]: isActive })}
                            />
                        </Typography>
                    </div>
                </div>

                <div className={clsx(styles.innerMenuWrapper)}>
                    {subMenu?.map(link => {
                        const { _uid: uid } = link;
                        return (
                            <SubmenuMobile
                                openMenus={openMenus}
                                toggleMenuVisibility={toggleMenuVisibility}
                                level={level + 1}
                                isNested
                                blok={link}
                                key={uid}
                            />
                        );
                    })}
                </div>
            </div>
        );
    };

    switch (blok.component) {
        case 'navigationLink':
            return renderNavigationLink(blok);
        default:
            return renderSubMenu(blok);
    }
};
